import history from '../../util/history'

const hideDetailView = () => {
  history.push('/segment_settings')

  return true
}

export default hideDetailView
